import React from "react";

export default function Footer() {
  return (
    <div>
      <div class="footer_main_wrapper float_left">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-12 col-sm-12">
              <div class="wrapper_second_about">
                <div class="wrapper_first_image">
                  <a href="/index">
                    <img
                      src="images/logo-white-t.png"
                      class="img-responsive"
                      alt="logo"
                      style={{ objectFit: "contain", width: "150px" }}
                    />
                  </a>
                </div>
                <p>
                  We are a full service Digital Marketing Agency all the
                  foundational tool you need.
                </p>
                <div class="counter-section">
                  <div class="ft_about_icon float_left">
                    <i class="flaticon-user"></i>
                    <div class="ft_abt_text_wrapper">
                      <p class="timer"> 62236</p>
                      <h4>total members</h4>
                    </div>
                  </div>
                  <div class="ft_about_icon float_left">
                    <i class="flaticon-money-bag"></i>
                    <div class="ft_abt_text_wrapper">
                      <p class="timer">7654</p>
                      <h4>total deposits</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-2 col-md-3 col-12 col-sm-4">
              <div class="wrapper_second_useful">
                <h4>usefull links </h4>

                <ul>
                  <li>
                    <a href="/about">
                      <i class="fa fa-angle-right"></i>About us
                    </a>
                  </li>
                  <li>
                    <a href="/investment">
                      <i class="fa fa-angle-right"></i>Investment Plan
                    </a>
                  </li>
                  <li>
                    <a href="/faq">
                      <i class="fa fa-angle-right"></i>FAQ
                    </a>{" "}
                  </li>
                  <li>
                    <a href="/contact">
                      <i class="fa fa-angle-right"></i>contact{" "}
                    </a>
                  </li>
                  
                  
                  {/* <li>
                    <a href="#">
                      <i class="fa fa-angle-right"></i>blog
                    </a>{" "}
                  </li> */}
                </ul>
              </div>
            </div>
            <div class="col-lg-2 col-md-3 col-12 col-sm-4">
              <div class="wrapper_second_useful wrapper_second_links">
                {/* <ul>
                  <li>
                    <a href="#">
                      <i class="fa fa-angle-right"></i>sitemap
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-angle-right"></i>FAQ{" "}
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-angle-right"></i>awards{" "}
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-angle-right"></i>testimonials
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-angle-right"></i>career
                    </a>{" "}
                  </li>
                </ul> */}
              </div>
            </div>

            <div class="col-lg-4 col-md-6 col-12 col-sm-12">
              <div class="wrapper_second_useful wrapper_second_useful_2">
                <h4>contact us</h4>

                <ul>
                  <li>
                    <h1>+1 (863) 617-6411</h1>
                  </li>
                  <li>
                    <a href="#">
                      <i class="flaticon-mail"></i>
                      support@treasuregrowth.com
                    </a>
                  </li>
                  {/* <li>
                    <a href="#">
                      <i class="flaticon-language"></i>www.example.com
                    </a>
                  </li> */}

                  {/* <li>
                    <i class="flaticon-placeholder"></i>110, B Street Kalani
                    Bagh Dewas, Madhya Pradesh, INDIA #455001
                  </li> */}
                </ul>
              </div>
            </div>

            <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
              <div class="copyright_wrapper float_left">
                <div class="copyright">
                  <p>
                    Copyright <i class="far fa-copyright"></i> 2021{" "}
                    <a href="/index"> Treasure Growth Investment</a>. all right
                    reserved -
                    {/* design by <a href="index.html">webstrot</a> */}
                  </p>
                </div>
                <div class="social_link_foter">
                  {/* <ul>
                    <li>
                      <a href="#">
                        <i class="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fab fa-google-plus-g"></i>
                      </a>
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
